<template>
  <b-modal size="md" v-model="show" centered title="Standartzuweisung"
  >
    <b-row>
      <b-tabs content-class="mt-3" style="padding-left: 15px;" v-model="currentTab">
        <b-tab title="Liste"></b-tab>
        <b-tab title="Baumstruktur"></b-tab>
      </b-tabs>
    </b-row>
    <b-row>
      <b-col style="">
        <b-form-input v-if="mode === 'list'" v-model="searchVal" placeholder="Suche" type="search" debounce="150"></b-form-input>
        <v-jstree v-if="mode === 'tree'" ref="js_tree" :allow-transition="false" :multiple="true"
                  style="flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem; height: 55vh; overflow: auto"
                  class="my-tree" :data="structure"
                  @item-click="onItemClicked"
                  show-checkbox></v-jstree>
        <v-jstree v-if="mode === 'list'" ref="js_list" :allow-transition="false" :multiple="true"
                  style="flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem; height: 55vh; overflow: auto"
                  class="my-tree" :data="listVal"
                  @item-click="onItemClicked"
                  show-checkbox></v-jstree>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" :disabled="!canContinue" variant="success" @click="onSelected">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import VJstree from 'vue-jstree'

export default {
  name: "SelectDefaultPlanningDialog",
  components: {VJstree},
  data() {
    return {
      show: false,
      loader: undefined,
      structure: [],
      selected: [],
      mitaFlat: [],
      mode: 'list',
      currentTab: 0,
      cleanStructure: [],
      searchVal: '',
    }
  },
  computed: {
    canContinue() {
      return true;
    },
    listVal() {
      if (this.searchVal === '') {
        return this.mitaFlat;
      } else {
        return this.mitaFlat.filter((data) => data.text.toLowerCase().includes(this.searchVal.toLowerCase()))
      }
    }
  },
  watch: {
    currentTab(n, o) {
      this.searchVal = '';
      if (n === 1) {
        this.mode = 'tree';
      } else {
        this.mode = 'list';
      }
      let selectedIds = this.selected.map((item) => item.id).join(',');
      this.clearSelection(selectedIds);
    },
  },
  methods: {
    computeMitas(data) {
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          let cur = {...data[i]}
          cur.children = []
          res.push(cur)
          res = res.concat(this.computeMitas(data[i].children))
        } else {
          let cur = {...data[i]}
          res.push(cur)
        }
      }
      res.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      return res;
    },
    onSelected() {
      this.show = false;
      this.$emit("default-selected", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    init(structure) {
      this.cleanStructure = JSON.parse(JSON.stringify(structure));
      this.structure = JSON.parse(JSON.stringify(structure));
      this.selected = [];
      console.log(this.structure)
      this.mitaFlat = this.computeMitas(this.structure);
    },
    preselect(preselectId, structure) {
      if (preselectId === structure.id) {
          structure.selected = true;
          this.selected.push(structure);
        }
      else if (structure.children && structure.children.length > 0) {
        for (let i = 0; i < structure.children.length; i++) {
          this.preselect(preselectId, structure.children[i]);
        }
      }
    },
    showDialog(selectedIds) {
      let selectionSplits = selectedIds.split(',');
      for (let i = 0; i < selectionSplits.length; i++) {
        if (this.mode === 'list') {
          for (let j = 0; j < this.mitaFlat.length; j++) {
            if (this.mitaFlat[j].id === selectionSplits[i]) {
              this.mitaFlat[j].selected = true;
              this.selected.push(this.mitaFlat[j]);
            }
          }
        } else {
          for (let j = 0; j < this.structure.length; j++) {
            this.preselect(selectionSplits[i], this.structure[j]);
          }
        }
      }
      this.show = true;
    },
    onItemClicked(data, item, e) {
      if (item.selected) {
        this.selected.push(item);
      } else {
        for (let i = 0; i < this.selected.length; i++) {
          if (this.selected[i].id === item.id) {
            this.selected.splice(i, 1);
            break
          }
        }
      }
      console.log(this.structure)
    },
    clearSelection(selectedIds) {
      this.structure = JSON.parse(JSON.stringify(this.cleanStructure));
      this.selected = [];
      this.mitaFlat = this.computeMitas(this.structure);
      let selectionSplits = selectedIds.split(',');
      for (let i = 0; i < selectionSplits.length; i++) {
        if (this.mode === 'list') {
          for (let j = 0; j < this.mitaFlat.length; j++) {
            if (this.mitaFlat[j].id === selectionSplits[i]) {
              this.mitaFlat[j].selected = true;
              this.selected.push(this.mitaFlat[j]);
            }
          }
        } else {
          for (let j = 0; j < this.structure.length; j++) {
            this.preselect(selectionSplits[i], this.structure[j]);
          }
        }
      }
    },
    getReturnData: function () {
      let res = [];
      for (let i = 0; i < this.selected.length; i++) {
        res.push({id: this.selected[i].id, name: this.selected[i].text})
      }
      return res;
    },
  }
}
</script>

<style>
.display_none {
  display: none;
}

.form-control:disabled {
  color: black;
}

.text-black {
  color: black;
}
</style>


<style scoped>
::v-deep .tab-content {
  display: none !important;
}
</style>
